module.exports = __webpack_public_path__ + "static/media/Piercing-nose-septum.7c2c681b.png";